"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.borderRadius = void 0;

var _react = require("@emotion/react");

var _util = require("../../util");

var borderRadius = (0, _util.rem)(6);
exports.borderRadius = borderRadius;

var base = function base(theme) {
  return /*#__PURE__*/(0, _react.css)("background-color:", theme.color.monochrome.white, ";border-radius:", borderRadius, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:base;"));
};

var footer = function footer(theme) {
  return /*#__PURE__*/(0, _react.css)("text-align:right;button+button{margin-left:", theme.spacing[5], ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:footer;"));
};

var styles = {
  base: base,
  footer: footer
};
exports.styles = styles;
//# sourceMappingURL=Card.styles.js.map